export default __webpack_public_path__ + "static/media/down-arrow.849f68db.svg";